import React, { useState, useEffect } from 'react';
import Select from 'react-select';

const Dropdown = (props) => {
  const [errorMsg, setErrorMsg] = useState('');

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: '#fafafa',
      cursor: 'pointer',
      boxShadow: 'none',
      borderColor: 'rgb(204, 204, 204)',

      '&:hover': {
        backgroundColor: '#fff'
      }
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: '#4b4b4b'
    }),
    menu: (provided, state) => ({
      ...provided,
      textAlign: 'left',
      marginTop: 0,
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      zIndex: 2
    }),
    option: (provided, state) => ({
      ...provided,
      color: '#4b4b4b',
      backgroundColor: '#fff',

      '&:hover': {
        backgroundColor: '#326ec8',
        color: '#fff'
      }
    })
  }

  useEffect(() => {
    if (props && props.error) {
      if (Object.keys(props.error).length) {
        Object.entries(props.error).forEach(([key, value]) => {
          if (key === props.name) {
            setErrorMsg(value.toString())
          }
        })
      } else if (errorMsg.length) {
        setErrorMsg('')
      }
    }
  }, [props, errorMsg])

  return (
    <div className={ `coral-Form-fieldwrapper ${(errorMsg && errorMsg.length) ? 'error' : ''}` }>
      <label className="coral-Form-fieldlabel">
        { props.label }
        <small className="required-label">{ props['data-required'] ? `${ props['data-required-label'] }`: '' }</small>
      </label>
      <Select
        options={ props.options }
        defaultValue={ props.defaultValue }
        value={ props.value }
        placeholder={ props.placeholder }
        onChange={ (selectedOption) => {
          props.onChange(selectedOption);
        }}
        menuPlacement="auto"
        styles={ customStyles }
      />
    </div>
  )
}

export default Dropdown;